// extracted by mini-css-extract-plugin
module.exports = {"body":"App_body__ZTvxg","container":"App_container__1MQN3"};